"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importStar(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const react_router_dom_1 = require("react-router-dom");
const context_1 = require("../../../context");
const reusables_1 = require("../../../comps/reusables");
const graphql_1 = require("../../../graphql");
const BaseAuthModal_1 = require("./BaseAuthModal");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const react_2 = require("@osmosys/react");
exports.AcceptInviteModal = props => {
    const { match } = use_react_router_1.default();
    const { appSettings } = react_1.useContext(context_1.OsmosysAppContext);
    const invitationQuery = react_hooks_1.useQuery(graphql_1.isInviteValid, {
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
        variables: {
            inviteCode: match.params.token,
        },
    });
    if (invitationQuery.loading) {
        return react_1.default.createElement(reusables_1.Loading, null);
    }
    const links = appSettings && appSettings.allowSignups ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_router_dom_1.Link, { to: "/login" }, "Login"),
        " or ",
        react_1.default.createElement(react_router_dom_1.Link, { to: "/signup" }, "Sign up"),
        ".")) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_router_dom_1.Link, { to: "/login" }, "Login"),
        "."));
    return (react_1.default.createElement(BaseAuthModal_1.BaseAuthModal, Object.assign({ osysSubType: "acceptInvite", getVars: ({ password, fullName }) => {
            return {
                data: {
                    email: invitationQuery.data &&
                        invitationQuery.data.isInviteValid &&
                        invitationQuery.data.isInviteValid.user.email,
                    fullName,
                    inviteCode: match.params.token,
                    password,
                },
            };
        }, title: invitationQuery.loading
            ? 'Loading invitation...'
            : invitationQuery.error
                ? 'Failed to load invitation'
                : 'Welcome to Osmosys', fields: invitationQuery.data &&
            invitationQuery.data.isInviteValid &&
            !invitationQuery.error
            ? ['email', 'fullName', 'password']
            : [], mutation: graphql_1.signupWithInvite, showButton: !!(invitationQuery.data &&
            invitationQuery.data.isInviteValid &&
            invitationQuery.data.isInviteValid.user &&
            !invitationQuery.error), buttonText: "Sign up", emailIsDisabled: true, variables: {
            email: invitationQuery.data &&
                invitationQuery.data.isInviteValid &&
                invitationQuery.data.isInviteValid.user.email,
            fullName: invitationQuery.data &&
                invitationQuery.data.isInviteValid &&
                invitationQuery.data.isInviteValid.user.fullName,
        }, linkComp: react_1.default.createElement(react_1.default.Fragment, null, !invitationQuery.error ? (react_1.default.createElement("p", { className: "text-muted" },
            "Finish setting up your Osmosys account using the invitation sent",
            ' ',
            moment_1.default(invitationQuery.data.isInviteValid.createdAt).format('LLLL'),
            ". ",
            react_1.default.createElement(react_router_dom_1.Link, { to: "/login" }, "Not you?"))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "UserInvite", action: "read", 
                // hideWarningIcon
                apolloError: invitationQuery.error }),
            react_1.default.createElement("p", { className: "text-muted mt-2" }, links)))) }, props)));
};
exports.default = exports.AcceptInviteModal;
//# sourceMappingURL=AcceptInviteModal.js.map